import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import {
  SignInInputModel,
  SignInOutputModel,
} from "src/app/admin/models/account-model";
import { AuthService } from "src/app/shared/providers/auth/auth-service.service";

@Component({
  selector: "app-admin-login",
  templateUrl: "./admin-login.component.html",
  styleUrls: ["./admin-login.component.scss"],
})
export class AdminLoginComponent implements OnInit {
  private _error = new Subject<string>();
  errorMessage: string;
  showPassword: boolean = false;
  captchaInput: string;
  captchaImageUrl: string;
  key: string;
  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private authService: AuthService
  ) {}

  loginForm: FormGroup;

  ngOnInit(): void {
    this._error.subscribe((message) => (this.errorMessage = message));
    this.initForm();
    this.refreshCaptcha();
  }

  initForm() {
    this.loginForm = this.fb.group({
      email: this.fb.control(null, Validators.required),
      password: this.fb.control(null, Validators.required),
      captchaInput: ["", [Validators.required, Validators.maxLength(4)]],
    });
  }
  login() {
    if (this.loginForm.valid) {
      const captchaInput = this.loginForm.value.captchaInput;

      // if (captchaInput !== "") {
      //   this.translate
      //     .get("AdminLogin.CaptchaInvalid")
      //     .subscribe((msg) => this._error.next(msg));

      //   this.refreshCaptcha(); // Regenerate captcha on invalid input
      //   this.loginForm.patchValue({ captchaInput: "" }); // Clear the captcha input field
      //   return;
      // }
      const signInModel = {
        email: this.loginForm.controls["email"].value,
        password: this.loginForm.controls["password"].value,
        captchaKey: this.key,
        captchaInput: this.loginForm.controls["captchaInput"].value,
      } as SignInInputModel;
      this.authService.adminLogin(signInModel).subscribe(
        (result: SignInOutputModel) => {
          if (result.accessToken == null) {
            this.authService.redirectToTwoFactorAuthPage(result);
          } else {
            this.authService.handleAdminLogin(
              result,
              "/admin/InternalFranchises"
            );
          }
        },
        (error) => {
          if (error.error.error.code === "498") {
            this.translate
              .get("AdminLogin.CaptchaInvalid")
              .subscribe((msg) => this._error.next(msg));
              setTimeout(() => {
                this.errorMessage = "";
              }, 5000);
            this.refreshCaptcha();
            return;
          }
          if (error.status == "403")
            //  this._error.next(error.error.error.message);
            this.translate
              .get(`AdminLogin.${error.error.error.message}`)
              .subscribe((msg) => this._error.next(msg));
              setTimeout(() => {
                this.errorMessage = "";
              }, 5000);
        }
      );
    } else {
      this.translate
        .get("AdminLogin.EmptyEmailOrPassword")
        .subscribe((msg) => this._error.next(msg));
        setTimeout(() => {
          this.errorMessage = "";
        }, 5000);
    }
    // console.log("form value", this.loginForm.value);
    // this.router.navigate(['admin/internalRestrictions']);
  }
  refreshCaptcha() {
    this.key = `captcha_${this.generateGuid()}`;
    this.authService.getCaptcha(this.key).subscribe((blob) => {
      this.captchaImageUrl = URL.createObjectURL(blob);
    });
  }
  ngOnDestroy() {
    URL.revokeObjectURL(this.captchaImageUrl);
  }
  generateGuid(): string {
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
